import pingPongActions from "./pingPong";
import allBuyerActions from "./buyers/allBuyers";
import crudBuyerActions from "./buyers/crudBuyers";
import { creditAppActions, creditLimitActions } from "./credit";
import allOrdersActions from "./orders/allOrders";
import crudOrderActions from "./orders/crudOrder";
import csvUploadOrdersActions from "./orders/csvUpload";
import tableActions from "./tables/tables";
import transferActions from "./transfers/transfers";
import allVendorActions from "./vendors/allVendors";
import crudVendorActions from "./vendors/crudVendor";
import settingsActions from "./settings";
import routeActions from "./routes";
import allTeamMembersActions from "./teams/allTeamMembers";
import crudTeamMembersActions from "./teams/crudTeamMember";
import allSessionsActions from "./sessions/allSessions";

const actions = {
  pingPong: { ...pingPongActions },
  buyers: {
    all: { ...allBuyerActions },
    crud: { ...crudBuyerActions },
  },
  credit: {
    app: { ...creditAppActions },
    limit: { ...creditLimitActions },
  },
  orders: {
    all: { ...allOrdersActions },
    crud: { ...crudOrderActions },
    csvUpload: { ...csvUploadOrdersActions },
  },
  transfers: { ...transferActions },
  vendors: {
    all: { ...allVendorActions },
    crud: { ...crudVendorActions },
  },
  teams: {
    all: { ...allTeamMembersActions },
    crud: { ...crudTeamMembersActions },
  },
  sessions: {
    all: { ...allSessionsActions },
  },
  table: { ...tableActions },
  routes: { ...routeActions },
  settings: { ...settingsActions },
};

export default actions;
